/**
 * Download a file using a data URI
 * @deprecated Use `downloadFileBlob` instead
 * @param filename 
 * @param data fully encoded data with mime type
 * @example
 * downloadFile('myfile.txt', 'data:text/plain;charset=utf-8,mycontent');
 */
export function downloadFile(filename: string, data: string): void {
  const element = document.createElement('a');
  element.setAttribute('href', data);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

/**
 * Download a file using a Blob, should allow for larger files and better performance
 */
export function downloadFileBlob(filename: string, fileContents: string, contentType = 'text/plain'): void {
  const blob = new Blob([fileContents], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
  * Copies text value to clipboard
  * @param {NotificationService} notifications - NotificationService instance
  * @param {string} value - file name or modality
  */
export function copyTextToClipboard(value: string): void {
  // utilizing mock element to copy value
  // without HTML input that's hidden
  const clipboardValue = document.createElement('input');
  document.body.appendChild(clipboardValue);
  clipboardValue.setAttribute('value', value);
  clipboardValue.select();
  document.execCommand('copy');
  document.body.removeChild(clipboardValue);
}

export interface PopupOptions {
  height?: number
  left?: number
  name?: string
  top?: number
  url?: string
  width?: number
}

export function openPopup(options: PopupOptions = {}): Window {
  const width = options.width || 400;
  const height = options.height || 600;
  const left = options.left || (window.screenX + (window.innerWidth - width) / 2);
  const top = options.top || (window.screenY + (window.innerHeight - height) / 2);
  return window.open(
    options.url || 'about:blank',
    options.name,
    `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`,
  );
}

export function isChrome(): boolean {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const isChromium = Boolean((window as any).chrome);
  const navigator = (window as any).navigator;
  const isOpera = Boolean((window as any).opr);
  const isIEedge = navigator.userAgent.indexOf('Edge') > -1;
  const isIOSChrome = Boolean(navigator.userAgent.match('CriOS'));
  return isIOSChrome || (isChromium && navigator.vendor === 'Google Inc.' && !isOpera && !isIEedge);
}
